const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

async function handleResponse(res: Response) {
  if (!res.ok) {
    if (res.status === 429) {
      throw new Error('リクエストが多すぎます。少し待ってから再試行してください。');
    }
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    throw new Error(err.detail || '解析に失敗しました');
  }
  return res.json();
}

export async function analyzeImage(file: File) {
  const body = new FormData();
  body.append('file', file);
  return handleResponse(await fetch(`${API_BASE}/analyze`, { method: 'POST', body }));
}

export async function compareImages(file1: File, file2: File) {
  const body = new FormData();
  body.append('file1', file1);
  body.append('file2', file2);
  return handleResponse(await fetch(`${API_BASE}/compare`, { method: 'POST', body }));
}
